<script setup lang="ts">
import { usePosts } from '../composables/usePageData';
import dayjs from 'dayjs';
import { Posts } from '../types/post';
import { createOneColor } from '../utils'

interface YearObj {
  years: number[]
  [year: number]: { 
    months: number[]
    [month: number]: Posts
  }
}

const posts = usePosts()
const yearObj: YearObj = { years: [] }

for(let post of posts) {
  const year = dayjs(post.frontmatter.date).year()
  const month = dayjs(post.frontmatter.date).month()
  if (yearObj[year]) {
    if (yearObj[year][month]) {
      yearObj[year][month].push(post)
    } else {
      yearObj[year].months.push(month)
      yearObj[year][month] = [post]
    }
  } else {
    yearObj[year] = {
      months: [month],
      [month]: [post]
    }
    yearObj.years.push(year)
  }
}

</script>

<template>
  <section class="block mx-auto mt-4 mb-16 px-4 max-w-screen-lg text-base v-timeline">
    <ul class="v-timeline__list">
      <li class="v-timeline__item" v-for="year in yearObj.years" :key="year" :style="{color: createOneColor()}">
        <h2 class="bg-current dark:bg-black rounded-lg text-center v-timeline__title"><span class="text-base">{{ year }}</span></h2>
        <ul class="v-timeline__list1">
          <li class="flex justify-between items-start my-4 v-timeline__item1" v-for="month in yearObj[year].months" :key="`${year}-${month}`">
            <div class="flex-shrink p-2 bg-current dark:bg-black rounded-lg rounded-tr-none v-timeline__time"><span class="text-base">{{ `${year}-${month+1}` }}</span></div>
            <div class="flex-1 h-full border-b-1 border-solid  dark:border-black v-timeline__line"></div>
            <ul class="flex-shrink w-[80%] p-6 bg-current dark:bg-black rounded-lg rounded-tl-none list-outside v-timeline__list2">
              <li class="w-full list-disc text-base v-timer__item2" v-for="post in yearObj[year][month]" :key="post.frontmatter.title">
                <a class="flex justify-between text-base hover:text-white/80 hover:underline hover:underline underline-offset-4" :href="post.url">
                  <span class="v-timeline__item2--left">{{ post.frontmatter.title }}</span>
                  <span class="flex-shrink w-22 text-nowrap ml-24 v-timeline__item2--right">{{ post.frontmatter.date }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<style lang="scss">
  .v-timeline__title {
    box-shadow: 2px 2px 10px rgba(0,0,0,.5);
  }
</style>